"use client"

import type { FunctionComponent } from "react"

import { IconButton } from "@jobteaser/spark/components/IconButton"
import { PencilFilled } from "@jobteaser/spark/components/Icons/PencilFilled"

import styles from "./Edition.module.css"

type EditionProps = {
  editUrl: string
  label: string
}

export const Edition: FunctionComponent<EditionProps> = ({ editUrl, label }) => {
  return (
    <IconButton
      icon={PencilFilled}
      variant="transparent"
      data-testid="event-details-edit-button"
      role="button"
      aria-label={label}
      className={styles.editButton}
      onClick={() => {
        window.open(editUrl, "_self")
      }}
    />
  )
}
